import React from 'react';
import { Mail, Phone } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function Contact() {
  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="section-container">
          <span className="section-label">Contact</span>
          <h1 className="page-title">Prendre contact</h1>
          <p className="page-subtitle">
            Un échange structuré pour comprendre votre contexte, vos priorités opérationnelles et déterminer ensemble la pertinence d'une intervention. Cet échange permet de clarifier les enjeux et de cadrer un éventuel périmètre de collaboration.
          </p>
          <div className="hero-actions">
            <a href="https://calendly.com/open-cortex/farid-amadet" target="_blank" rel="noopener noreferrer">
              <Button className="btn-primary">
                Prendre RDV
              </Button>
            </a>
          </div>
        </div>
      </section>

      {/* Expectations Section */}
      <section className="expectations-section">
        <div className="section-container">
          <h2>À quoi s'attendre</h2>
          <div className="expectations-list">
            <div className="expectation-item">
              <div className="expectation-number">1</div>
              <div className="expectation-content">
                <h3>Premier échange</h3>
                <p>
                  Présentation de votre contexte, de vos enjeux opérationnels et de vos priorités. Questions ciblées pour clarifier la situation et identifier les leviers pertinents.
                </p>
              </div>
            </div>

            <div className="expectation-item">
              <div className="expectation-number">2</div>
              <div className="expectation-content">
                <h3>Analyse de la pertinence</h3>
                <p>
                  Évaluation conjointe de l'intérêt d'une intervention Open Cortex dans ce contexte précis. Si le besoin relève d'un autre type d'accompagnement, nous vous l'indiquons.
                </p>
              </div>
            </div>

            <div className="expectation-item">
              <div className="expectation-number">3</div>
              <div className="expectation-content">
                <h3>Proposition de collaboration</h3>
                <p>
                  Si l'intervention est pertinente, envoi d'un devis détaillé précisant le périmètre, les livrables, les étapes et les modalités. La décision de poursuivre vous appartient.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Methods Section */}
      <section className="contact-methods-section">
        <div className="section-container">
          <h2>Comment nous joindre</h2>
          <div className="contact-grid">
            <div className="contact-method">
              <div className="contact-icon">
                <Mail className="icon" />
              </div>
              <div className="contact-details">
                <h3>Email</h3>
                <a href="mailto:open-cortex@proton.me" className="contact-link">
                  open-cortex@proton.me
                </a>
              </div>
            </div>

            <div className="contact-method">
              <div className="contact-icon">
                <Phone className="icon" />
              </div>
              <div className="contact-details">
                <h3>Téléphone</h3>
                <a href="tel:+33775713978" className="contact-link">
                  +33 7 75 71 39 78
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Principles Section */}
      <section className="principles-section">
        <div className="section-container">
          <div className="principles-content">
            <h2>Principes de collaboration</h2>
            <div className="principles-grid-horizontal">
              <div className="principle-item">
                <h3>Transparence</h3>
                <p>Positionnement clair sur le périmètre, la valeur et les limites de chaque intervention.</p>
              </div>
              <div className="principle-item">
                <h3>Clarté</h3>
                <p>Chaque mission est cadrée par un devis précis, avec des livrables identifiés et un déroulé explicite.</p>
              </div>
              <div className="principle-item">
                <h3>Respect</h3>
                <p>Travail en collaboration avec les équipes, dans le respect du fonctionnement existant et des responsabilités de chacun.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
